import React, { useState, useEffect, Fragment, useRef } from 'react';
import Select, { StylesConfig } from 'react-select';
import { useTranslation } from 'react-i18next';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { KTIcon } from '../../_metronic/helpers';
import fetchAPI from '../../common/fetchAPI';
import { addAccountBillingRate, updateAccountBillingRate, updateIsLoading } from '../billing/billingRateSlice';
import { ShowToast } from '../../common/Toastr';
import { validateCultureNumber, determineCommaSeprater, formatNumberCustomoriginal, parseLocalizedNumber, formatNumberCustomoriginalapiv2
    , dropDownSelectionStyles, dateFormatByAccountCulture, getValueFromResource } from '../../common/timeLiveFunction';

const initialValues = {
    BillingRateCurrencyId: 0,
    EmployeeRateCurrencyId: 0,
    BillingRate: 0,
    EmployeeRate: 0,
    StartDate: new Date(),
    EndDate: new Date(),
    IsSelected: false,
    IsDisabled: false
}

const BillingRateAddUpdate = (props: any) => {
    const { SystemBillingRateTypeId } = props.obj
    const closeButtonRef = useRef<HTMLButtonElement | null>(null);
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const { accountBillingRateId, accountProjectRoleId, accountProjectEmployeeId, accountWorkTypeId, accountProjectTaskId, accountEmployeeId } = useAppSelector((state) => state.billingRate);
    const { decimalPlaces, accountBaseCurrencyId, maxMenuHeight, CurrentCultureDateFormat, cultureInfoName, dateInsertionFormat, calendarStartDay } = useAppSelector((state) => state.globalState)
    const [billingRateResponse, setBillingRateResponse] = useState<any | ''>(initialValues);
    const [currenciesResponse, setCurrenciesResponse] = useState<any | ''>([]);

    useEffect(() => {
        renderAccountBillingRate();
    }, [accountBillingRateId]);

    const renderAccountBillingRate = async () => {
        const response = await fetchAPI(`api/V2/BillingRates/GetAllDataInSingle?AccountBillingRateId=${accountBillingRateId}`, 'GET', '', true);
        const json = await response.json();
        json["AccountCurrency"].map((item: any) => {
            item.value = item.AccountCurrencyId;
            item.label = item.CurrencyCode;
            delete item.AccountCurrencyId;
            delete item.CurrencyCode;
        });
        setCurrenciesResponse(json["AccountCurrency"]);

/* const formattedBillingRate = json["AccountBillingRate"]?.[0]?.BillingRate 
    ? formatNumberCustomoriginalapiv2(
        cultureInfoName.toString(),
        json["AccountBillingRate"][0].BillingRate.toFixed(decimalPlaces),
        decimalPlaces
    )
    : formatNumberCustomoriginalapiv2(
        cultureInfoName.toString(),
        "0",
        decimalPlaces
    );
    
const formattedEmployeeRate = json["AccountBillingRate"]?.[0]?.EmployeeRate 
    ? formatNumberCustomoriginalapiv2(
        cultureInfoName.toString(),
        json["AccountBillingRate"][0].EmployeeRate.toFixed(decimalPlaces),
        decimalPlaces
    )
    : formatNumberCustomoriginalapiv2(
        cultureInfoName.toString(),
        "0",
        decimalPlaces
    ); */
    //formatNumberCustomoriginalapiv2(cultureInfoName.toString(), json["AccountBillingRate"][0].EmployeeRate.toFixed(decimalPlaces),decimalPlaces)
          const formattedBillingRate = formatNumberCustomoriginalapiv2(
            cultureInfoName.toString(), 
            0, 
            decimalPlaces
          );
            const formattedEmployeeRate = formatNumberCustomoriginalapiv2(
            cultureInfoName.toString(), 
            0, 
            decimalPlaces
          );
        setBillingRateResponse({
            ...billingRateResponse,
            BillingRateCurrencyId: accountBillingRateId != 0 ? json["AccountBillingRate"][0].BillingRateCurrencyId : accountBaseCurrencyId,
            EmployeeRateCurrencyId: accountBillingRateId != 0 ? json["AccountBillingRate"][0].EmployeeRateCurrencyId : accountBaseCurrencyId,
            BillingRate: accountBillingRateId != 0 ? formatNumberCustomoriginalapiv2(cultureInfoName.toString(), json["AccountBillingRate"][0].BillingRate, decimalPlaces) : '',
            //EmployeeRate: accountBillingRateId != 0 ? json["AccountBillingRate"][0].EmployeeRate.toFixed(2) : 0,
            EmployeeRate: accountBillingRateId != 0 ? formatNumberCustomoriginalapiv2(cultureInfoName.toString(), json["AccountBillingRate"][0].EmployeeRate, decimalPlaces) : '',
            // StartDate: accountBillingRateId != 0 ? new Date(json["AccountBillingRate"][0].StartDate) : new Date(),
            // EndDate: accountBillingRateId != 0 ? new Date(json["AccountBillingRate"][0].EndDate) : new Date()
            StartDate: accountBillingRateId != 0 ? dateFormatByAccountCulture(moment.parseZone(json["AccountBillingRate"][0].StartDate).format(dateInsertionFormat), cultureInfoName.toString()) : new Date(),
            EndDate: accountBillingRateId != 0 ? dateFormatByAccountCulture(moment.parseZone(json["AccountBillingRate"][0].EndDate).format(dateInsertionFormat), cultureInfoName.toString()) : new Date()
        })
    }

    const onChange = (data: any, filterName: any) => {
        setBillingRateResponse((billingRateResponse: any) => ({
            ...billingRateResponse,
            BillingRateCurrencyId: filterName.name == "billingRateCurrency" ? currenciesResponse.filter((x: any) => x.value == data.value)[0].value : billingRateResponse.BillingRateCurrencyId,
            EmployeeRateCurrencyId: filterName.name == "employeeRateCurrency" ? currenciesResponse.filter((x: any) => x.value == data.value)[0].value : billingRateResponse.EmployeeRateCurrencyId
        }));
    }

    const onDateChange = (date: any, name: any) => {       
        // if 
        // (name == "StartDate" && moment(date).format(dateInsertionFormat) > moment(billingRateResponse.EndDate).format(dateInsertionFormat)) {
        //     ShowToast('Warning', t('Start date cannot be later than end date.'), "warning", "toast-top-right");
        // } else if (name == "EndDate" && moment(date).format(dateInsertionFormat) < moment(billingRateResponse.StartDate).format(dateInsertionFormat)) {
        //     ShowToast('Warning', t('End date cannot be earlier than start date.'), "warning", "toast-top-right");
        // } else 
            
        //     {
            if (accountBillingRateId === 0) {
                dispatch(updateIsLoading(true));
                validateAccountBillingRate(date, name);
            } else {
                validateAccountBillingRate(date, name);
                setBillingRateResponse({
                    ...billingRateResponse,
                    StartDate: name == "StartDate" ? date : billingRateResponse.StartDate,
                    EndDate: name == "EndDate" ? date : billingRateResponse.EndDate
                })
            }
        //}
    }

    const validateAccountBillingRate = async (date: any, name: string) => {
        const response = await fetchAPI(`api/V2/BillingRates/GetAccountBillingRatesByStartDateAndEndDate/${accountProjectRoleId}/${accountProjectEmployeeId}/${accountProjectTaskId}/${accountWorkTypeId}/${accountEmployeeId}/${moment(name == "StartDate" ? date : billingRateResponse.StartDate).format(dateInsertionFormat)}/${moment(name == "EndDate" ? date : billingRateResponse.EndDate).format(dateInsertionFormat)}`, 'GET', '', true);
        const json = await response.json();     
        dispatch(updateIsLoading(false));
        if (json.length > 0 && json[0].IsAvailable > 0) {
            if (accountBillingRateId === 0) {
                setBillingRateResponse({
                    ...billingRateResponse,
                    StartDate: name == "StartDate" ? date : billingRateResponse.StartDate,
                    EndDate: name == "EndDate" ? date : billingRateResponse.EndDate,
                    IsDisabled: accountBillingRateId != 0 ? false : true
                })
                ShowToast('Warning', t('The billing rate date range you selected overlaps with an existing date range.'), "warning", "toast-top-right");
            }
        } else {
            setBillingRateResponse({
                ...billingRateResponse,
                StartDate: name == "StartDate" ? date : billingRateResponse.StartDate,
                EndDate: name == "EndDate" ? date : billingRateResponse.EndDate,
                IsDisabled: accountBillingRateId != 0 ? false : false
            })
        }
    }

    const onHandleChangeStatus = (e: any) => {
        setBillingRateResponse({
            ...billingRateResponse,
            IsSelected: e.target.checked ? true : false
        })
    }

    const resetForm = () => {
        setBillingRateResponse({
            ...initialValues,
            BillingRateCurrencyId: accountBaseCurrencyId,
            EmployeeRateCurrencyId: accountBaseCurrencyId,
            BillingRate: '',
            EmployeeRate: '',
            StartDate: new Date(),
            EndDate: new Date(),
            IsDisabled: false
        });
    };
    const onAddUpdateBillingRate = async () => {
        if (moment(billingRateResponse.StartDate).format(dateInsertionFormat) > moment(billingRateResponse.EndDate).format(dateInsertionFormat)) {
            ShowToast('Warning', t('Start date cannot be later than end date.'), "warning", "toast-top-right");
        } else {
            dispatch(updateIsLoading(true));
                                        // Normalize numeric values before creating object
                        const normalizedEmployeeRate = parseLocalizedNumber(billingRateResponse.EmployeeRate);
                        const normalizedBillingRate = parseLocalizedNumber(billingRateResponse.BillingRate);
            let objectAdd = {
                SystemBillingRateTypeId: Number(SystemBillingRateTypeId),
                AccountProjectEmployeeId: accountProjectEmployeeId,
                AccountProjectRoleId: accountProjectRoleId,
                AccountEmployeeId: accountEmployeeId,
                AccountProjectTaskId: accountProjectTaskId,
                BillingRate: normalizedBillingRate,
                EmployeeRate: normalizedEmployeeRate,
                BillingRateCurrencyId: billingRateResponse.BillingRateCurrencyId,
                EmployeeRateCurrencyId: billingRateResponse.EmployeeRateCurrencyId,
                StartDate: moment(billingRateResponse.StartDate).format(dateInsertionFormat),
                EndDate: moment(billingRateResponse.EndDate).format(dateInsertionFormat),
                AccountWorkTypeId: accountWorkTypeId,
                IsBillingRateUpdate: false,
                AccountBaseCurrencyId: accountBaseCurrencyId
            }

            accountBillingRateId == 0 ?
                dispatch(addAccountBillingRate(objectAdd)).then((result) => {
                    if (Number(result.payload.id) > 0) {
                        ShowToast('Success', 'Record Inserted successfully', "success", "toast-top-right");
                        resetForm();
                    } else {
                        ShowToast('Error', 'Record Inserted failed', "error", "toast-top-right");
                        resetForm();
                    }
                    if (closeButtonRef.current) closeButtonRef.current.click();
                }).catch((error) => {
                    console.error(error);
                    if (closeButtonRef.current) closeButtonRef.current.click();
                })
                :
                dispatch(updateAccountBillingRate(objectAdd)).then((result) => {
                    if (Number(result.payload.id) > 0) {
                        ShowToast('Success', 'Record updated successfully', "success", "toast-top-right");
                        resetForm();
                    } else {
                        ShowToast('Error', 'Record updated failed', "error", "toast-top-right");
                        resetForm();
                    }
                    if (closeButtonRef.current) closeButtonRef.current.click();
                }).catch((error) => {
                    console.error(error);
                    if (closeButtonRef.current) closeButtonRef.current.click();
                });
        }
    }
    
    return (
        <Fragment>
            <div className='card-body py-3' style={{ overflowY: 'auto' }}>
                <div className='row'>
                    <div className="col-md-6">
                        <label className="form-label fs-7 fw-normal mb-2">
                            {/* {t('Billing Rate Currency')} */}
                            {getValueFromResource('Billing Rate Currency',dispatch, t)}
                            </label>
                        <Select
                            value={currenciesResponse.filter((x: any) => x.value == billingRateResponse.BillingRateCurrencyId)}
                            className="basic-single"
                            classNamePrefix="select"
                            name="billingRateCurrency"
                            onChange={(e, name) => onChange(e, name)}
                            options={currenciesResponse}
                            styles={dropDownSelectionStyles}
                            maxMenuHeight={maxMenuHeight}
                        />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label fs-7 fw-normal mb-2">
                            {/* {t('Employee Rate Currency')} */}
                            {getValueFromResource('Employee Rate Currency',dispatch, t)}
                            </label>
                        <Select
                            value={currenciesResponse.filter((x: any) => x.value == billingRateResponse.EmployeeRateCurrencyId)}
                            className="basic-single"
                            classNamePrefix="select"
                            name="employeeRateCurrency"
                            onChange={(e, name) => onChange(e, name)}
                            options={currenciesResponse}
                            styles={dropDownSelectionStyles}
                            maxMenuHeight={maxMenuHeight}
                        />
                    </div>
                </div>
                <div className='row spacingBetweenRows'>
                    <div className="col-md-6">
                        <label className="form-label fs-7 fw-normal mb-2">
                            {/* {t('Billing Rate')} */}
                            {getValueFromResource('Billing Rate',dispatch, t)}
                            </label>
                        <input
                            type="text"
                            className="form-control"
                            name="BillingRate"
                            value={billingRateResponse.BillingRate}
                            onChange={(e) => {
                                  const val = e.target.value;
                                    if (validateCultureNumber(val, cultureInfoName.toString(), decimalPlaces)) {
                                setBillingRateResponse({
                                    ...billingRateResponse,
                                    BillingRate: val
                                })
  }
                            }}
  onBlur={(e) => {
                //const isUSCulture = /* your culture check */;
                let val = e.target.value.trim();
                const formatted = formatNumberCustomoriginal(
                    cultureInfoName.toString(),
                    val,                      
                    decimalPlaces
                );
      setBillingRateResponse({
                ...billingRateResponse,
                BillingRate: formatted
            });
      
  }}
                        />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label fs-7 fw-normal mb-2">
                            {/* {t('Employee Rate')} */}
                            {getValueFromResource('Employee Rate',dispatch, t)}
                            </label>
                        <input
                            type="text"
                            className="form-control"
                            name="EmployeeRate"
                            value={billingRateResponse.EmployeeRate}
                            onChange={(e) => {
                                  const val = e.target.value;
                                    if (validateCultureNumber(val, cultureInfoName.toString(), decimalPlaces)) {
                                setBillingRateResponse({
                                    ...billingRateResponse,
                                    EmployeeRate: val
                                })
  }
                            }}
  onBlur={(e) => {
                //const isUSCulture = /* your culture check */;
                let val = e.target.value.trim();
                const formatted = formatNumberCustomoriginal(
                    cultureInfoName.toString(),
                    val,                      
                    decimalPlaces
                );
      setBillingRateResponse({
                ...billingRateResponse,
                EmployeeRate: formatted
            });
      
  }}
                        />
                    </div>
                </div>
                <div className='row spacingBetweenRows'>
                    <div className="col-md-6">
                        <label className="form-label fs-7 fw-normal mb-2">
                            {/* {t('Start Date')} */}
                            {getValueFromResource('Start Date',dispatch, t)}
                            </label>
                        <div className="wrapper">
                            <DatePicker
                                selected={billingRateResponse.StartDate}
                                onChange={(date) => onDateChange(date, "StartDate")}
                                calendarStartDay={calendarStartDay}
                                className="form-control form-control-dark btn-icon-dark btn-text-dark"
                                dateFormat={CurrentCultureDateFormat.toString()}
                            >
                            </DatePicker>
                            <i className="insideField-Icons ki-outline ki-calendar text-gray"></i>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <label className="form-label fs-7 fw-normal mb-2">
                            {/* {t('End Date')} */}
                            {getValueFromResource('End Date',dispatch, t)}
                            </label>
                        <div className="wrapper">
                            <DatePicker
                                selected={billingRateResponse.EndDate}
                                onChange={(date) => onDateChange(date, "EndDate")}
                                calendarStartDay={calendarStartDay}
                                className="form-control form-control-dark btn-icon-dark btn-text-dark"
                                dateFormat={CurrentCultureDateFormat.toString()}
                            >
                            </DatePicker>
                            <i className="insideField-Icons ki-outline ki-calendar text-gray"></i>
                        </div>
                    </div>
                </div>
                {/* <div className='row spacingBetweenRows'>
                    <div className="col-md-6">
                        <label className="form-label fs-7 fw-normal mb-2">                         
                            {getValueFromResource('Update all records within this range',dispatch, t)}
                            </label>
                        <div className="form-check form-switch form-check-custom">
                            <input
                                type="checkbox"
                                className="form-check-input custom-padding-right h-15px w-30px"
                                checked={billingRateResponse.IsSelected}
                                onChange={(e) => { onHandleChangeStatus(e) }}
                            />
                        </div>
                    </div>
                </div> */}
            </div>
            <div className='card-footer pt-4'>
                <div className='d-flex flex-end'>
                    <button
                        ref={closeButtonRef}
                        type="button"
                        className="btn btn-secondary btn-bs-btn-font-weight me-2 btn-sm fs-7"
                        id="kt_OffCanvas"
                    >
                        {/* {t('Cancel')} */}
                        {getValueFromResource('Cancel',dispatch, t)}
                    </button>
                    <button
                        className='btn btn-sm btn-primary'
                        type='button'
                        onClick={() => { onAddUpdateBillingRate() }}
                        disabled={billingRateResponse.IsDisabled}
                    >
                        {/* {t('Save')} */}
                        {getValueFromResource('Save',dispatch, t)}
                    </button>
                </div>
            </div>
        </Fragment>
    )
}

export default BillingRateAddUpdate